import { createSlice } from '@reduxjs/toolkit'

const initial_State = {
    userinfo: {
        token: null,
        isProvider: null,
        userEmail: "",
        userTimeOut: null,
        userId: null,
        userName: "",
        userType: "",
        roleId: "",
        roleName: "",
        eRxEmail: null,
        phoneNumber : "",
        eRxId: null,
        locationID: null,
        providerID: null,
        encounterSettingId: null,
        userPassword: "",
        userModuleRights: null,
        twoFactorRequired: false,
        twoFactorViaAuthenticator: false,
        twoFactorViaEmail: false,
        twoFactorViaText: false,
    },
    practiceDetails: {
        address1: "",
        city: "",
        clientDetailId: null,
        contextDetailId: null,
        id: null,
        isPracticeRights: null,
        name: null,
        officePhoneNum: null,
        state: null,
        zipCode: null,
    },
    practicePopup: false
}



export const UserAuthSlice = createSlice({
    name: 'UserAuthSlice',
    initialState: initial_State,
    reducers: {
        signin: (state, action) => {
            return {
                ...state,
                userinfo: {
                    ...state.userinfo,
                    ...action.payload
                }
            }
        },
        refreshToken: (state, action) => {
            return {
                ...state,
                userinfo: {
                    ...state.userinfo,
                    token: action.payload
                }
            }
        },
        signout: (state) => {
            return {
                ...state,
                userinfo: {
                    ...state.userinfo,
                    token: null,
                    userPassword: ""
                }
            }
        },
        addPracticeDetails: (state, action) => {
            return {
                ...state,
                practiceDetails: {
                    ...state.practiceDetails,
                    ...action.payload
                }
            }
        },
        addUserInfo: (state, action) => {
            return {
                ...state,
                userinfo: {
                    ...state.userinfo,
                    ...action.payload
                }
            }
        },
        userAuthAction: (state, action) => {
            return {
                ...state,
                practiceDetails: action.payload.practiceDetails,
                userinfo: {
                    ...state.userinfo,
                    ...action.payload.userInfo
                }
            }
        },
        UpdatePracticePopupAction: (state, action) => {
            return {
                ...state,
                practicePopup: action.payload
            }
        },
    },

})

// Action creators are generated for each case reducer function
export const { signin, signout, refreshToken, addPracticeDetails, addUserInfo, userAuthAction, UpdatePracticePopupAction } = UserAuthSlice.actions

export default UserAuthSlice.reducer
